import { ChevronRight } from 'lucide-react';
import { Fragment } from 'react';
import { AppLink } from '@/components/ui/AppLink';
import { List } from '@/components/ui/List';
import { useT } from '@/lib/i18n';

export interface Crumb {
  label: string;
  /** Omit on the last crumb — it is the current page. */
  to?: string;
}

/**
 * Where you are: `Home › Shop › Black Markino`. The last item is the current page (`aria-current`),
 * the separators are decorative. Pair it with `breadcrumbJsonLd()` for structured data.
 */
export function Breadcrumbs({ items }: { items: readonly Crumb[] }) {
  const t = useT();
  return (
    <nav aria-label={t('nav.breadcrumb')} className="breadcrumbs">
      <List className="breadcrumbs__list">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <Fragment key={`${item.label}-${String(index)}`}>
              <li className="breadcrumbs__item">
                {item.to && !last ? (
                  <AppLink to={item.to} className="breadcrumbs__link">
                    {item.label}
                  </AppLink>
                ) : (
                  <span aria-current={last ? 'page' : undefined}>{item.label}</span>
                )}
              </li>
              {last ? null : (
                <li className="breadcrumbs__sep" aria-hidden="true">
                  <ChevronRight size={14} />
                </li>
              )}
            </Fragment>
          );
        })}
      </List>
    </nav>
  );
}
